import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

export interface TrunkReportEvent {
  type: string;
  vehicle: string;
  state: string;
  date: string;
  latitude: number;
  longitude: number;
  speed: number;
  label: string;
  movement: number;
  ignition: number;
  sensor_id: string;
  is_inside_safe_zone: boolean;
  open_duration: number | null;
  opened_by_command: boolean;
  user: string;
}

export interface TrunkReportSummary {
  events: TrunkReportEvent[];
  statistics: {
    trunk_openings: number;
    door_openings: number;
    lock_operations: number;
    total_events: number;
  };
  period: {
    start: string;
    end: string;
  };
}

export interface TrunkReportParams {
  start_period: string;
  end_period: string;
  vehicles: string;
}

export interface BackendFile {
  id: number;
  created_at: string;
  updated_at: string;
  date: string;
  storage: string;
  path: string;
  name: string;
  original_name: string | null;
  content_type: string;
  size: number;
  user_id: number | null;
  client_id: number;
  status?: number;
}

export interface DownloadIndexResponse {
  data?: BackendFile[];
  files?: BackendFile[];
}

export const trunkReportService = {
  async index(params: TrunkReportParams) {
    const response = await api.get<TrunkReportSummary>("/trunk_report", {
      params,
    });
    return response.data;
  },

  async pdf(params: TrunkReportParams) {
    const response = await api.get("/trunk_report/pdf", {
      params,
    });
    return response.data;
  },

  async downloadIndex({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<BackendFile>>("/downloads", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async downloadFile(fileId: string | number): Promise<Blob> {
    const response = await api.get(`/downloads/${fileId}/file`, {
      responseType: "blob",
    });
    return response.data;
  },

  async deleteDownload(downloadId: string | number): Promise<void> {
    await api.delete(`/downloads/${downloadId}`);
  },

  async xlsx(params: TrunkReportParams) {
    const response = await api.get("/trunk_report/xlsx", {
      params,
      responseType: "blob",
    });
    return response.data;
  },
};
